var useprodna;
var useintoprodna; // 转入基金
var usefundcode;
var useintofundcode;
var outShareType; //转出份额类别
var inShareType; //转入基金份额类型
var math;
var px = 0;
var sortType = "1";
var fundType = "ALL";
var minBalShare; //最低持有份额
var fundMonyInfo = [];
var beforeAvailableShare; //前收费可用份额
var afterAvailableShare; //后收费可用份额
var holdShare;
var availableShare; //可用份额
var maxSoldValue; //最大卖出份额
var conversionShare; //转出份额

var personalFundCode;
var flag = 0; //请求转换基金时传给后端的标志

var summary = "";
var fundInstructions = "";
var fundContract = "";
var isSelect = false;
var isSelect1 = true;
var hasFundSummary = "";

var creditNum; //剩余鹏豆数
var isAllowUse; // 是否可以使用鹏豆
var noPengDouContinueNextFlag = "0"; // 是否使用鹏豆
var creditUseType; // 鹏豆使用场景
var creditValue; // 鹏豆使用数
var maxLimitAmt = ""; // 转入基金的最大限额
var nav; // 转出基金的净值
var fee_const; // 转入基金的最大金额
var maxNum; // 转出基金的金额
var fundRiskLvCn; // 转入基金的风险等级中文

var redeemCashAcctId;
var redeemBankAcctNo;
var redeemTotalShare;
var redeemBankCardMsg;
var transSharetype;
var isEnable;
var isSelected;

removeValue("redeemCashAcctId", false);
removeValue("redeemBankAcctNo", false);
removeValue("redeemTotalShare", false);

$(function () {
  $("#hotProductsRecommend").addClass("none");

  //查询相关协议点击事件
  initProtocolEvent();

  if (isRealName()) {
    var cardLen = loadValue("cardLen", false);
    if (!isNull(cardLen) && Number(cardLen) > 0) {
      getTransferInfo();
    } else {
      $("#noCard").removeClass("none");
      $("#tipMsg").html("暂无可转换产品");
    }
  } else {
    $("#noCard").removeClass("none");
    $("#tipMsg").html("暂无可转换产品");
  }

  setHotRecommend();
  //键盘事件enter监听，出发登录事件
  document.onkeydown = function (event) {
    var e = event || window.event || arguments.callee.caller.arguments[0];
    if (e && e.keyCode == 13) {
      search();
    }
  };
  $("#conversionShare").bind("input propertychange", function () {
    setFundRate();
  });
  // toApi_toAcCg("S090081", { useType: "C01" }, function (data) {
  //   isAllowUse = data.isAllowUse; //是否允许使用鹏豆 0：不允许 1：允许  白名单
  //   creditNum = data.creditNum ? data.creditNum : 0; //剩余鹏豆数
  //   if (isAllowUse == "1") {
  //     // 白名单范围且前收费
  //     $("#useBeanDiv").show();
  //     if (creditNum < 1) {
  //       $("#unChecked").show();
  //       $("#useBean").hide();
  //       $("#beanTips").html("鹏豆不足");
  //     } else {
  //       $("#unChecked").hide();
  //       $("#useBean").show();
  //       $("#beanTips").html(
  //         "使用1个鹏豆抵扣转换手续费，根据基金交易规则存在未能完全抵扣的情况，具体抵扣金额以实际为准"
  //       );
  //     }
  //   }
  // });
});
function getBean(fundCode) {
  toApi_toAcCg(
    "S090081",
    { useType: "C01", fundCode: fundCode },
    function (data) {
      isAllowUse = data.isAllowUse; //是否允许使用鹏豆 0：不允许 1：允许  白名单
      creditNum = data.creditNum ? data.creditNum : 0; //剩余鹏豆数
      if (isAllowUse == "1") {
        // 白名单范围且前收费
        $("#useBeanDiv").show();
        if (creditNum < 1) {
          $("#unChecked").show();
          $("#useBean").hide();
          $("#beanTips").html("鹏豆不足");
        } else {
          $("#unChecked").hide();
          $("#useBean").show();
          $("#beanTips").html(
            "使用1个鹏豆抵扣转换手续费，根据基金交易规则存在未能完全抵扣的情况，具体抵扣金额以实际为准"
          );
        }
      }
    }
  );
}
function getFundType() {
  toApi_toAcCg(
    "S15Q705",
    { dictCode: "fund_column_type", state: "1" },
    function (data) {
      if (data && data.jsonData && data.jsonData.length > 0) {
        var fundTypeList = data.jsonData;
        var html =
          '<a href="javascript:void(0)" onclick="getTopList(\'ALL\')" id="tALL" class="active">全部<i></i></a>';

        $("#tab").html(function () {
          for (var i = 0; i < fundTypeList.length; i++) {
            html +=
              '<a href="javascript:void(0)" onclick="getTopList(\'' +
              fundTypeList[i].valueCode +
              '\')" id="t' +
              fundTypeList[i].valueCode +
              '">' +
              fundTypeList[i].valueName +
              "</a>";
          }
          return html;
        });
        getList(1, fundType, sortType, px, usefundcode, outShareType);
      }
    }
  );
}

function initProtocolEvent() {
  try {
    $("#fundTradingProtocols").on("click", function (e) {
      e.stopPropagation();
      openAgreement();
    });

    $("#fundTradingRiskTips").on("click", function (e) {
      e.stopPropagation();
      showRiskTips();
    });

    $("#fundTradingRiskTips1").on("click", function (e) {
      e.stopPropagation();
      showRiskTips();
    });
  } catch (error) {
    console.error(error);
  }
}

function chooseOutType(type) {
  alert("暂不支持后收费转换");
  return;
  if (outShareType === type) {
    return;
  }
  setTransformationTip(type);
  outShareType = type;
  $("#sc2").addClass("none");
  $("#sc1").removeClass("none");
  if (type === "0") {
    $("#beforeShow").addClass("on");
    $("#afterShow").removeClass("on");
  } else {
    $("#beforeShow").removeClass("on");
    $("#afterShow").addClass("on");
  }
  clearTipMsg();
}

function getTransferInfo() {
  pageno = 1;
  var thisURL = window.location.href;
  var args = thisURL.split("?");
  if (args[0] == thisURL) {
    /*参数为空*/ if (isRealName()) {
      toApi(
        "qrywalletfundcode.tml",
        function (data2) {
          personalFundCode = data2.personalFundCode;
          // apiCcjl(1);
          getTransPosition(1);
        },
        "fundTrading",
        usefundcode
      );
    } else {
      //TODO 非实名认证用户处理逻辑
    }
  } else {
    var retval = [];
    var str = args[1];
    args = str.split("&");
    for (var i = 0; i < args.length; i++) {
      str = args[i];
      var arg = str.split("=");
      if (arg.length <= 1) continue;
      retval.push(decodeURI(arg[1]));
    }
    fundswitch(
      retval[0],
      retval[1],
      retval[2],
      retval[3],
      retval[4],
      retval[5],
      retval[6],
      retval[7]
    );
  }
}

function apiCcjl(pageno) {
  toApi(
    "fundpositionslist.tml?playFlg=0&switchFlg=1&pageno=" +
      pageno +
      "&pagesz=10",
    function (data) {
      if (data.funds.length === 0 && pageno === 1) {
        $("#noCard").removeClass("none");
        $("#tipMsg").html("暂无可转换产品");
        return;
      }

      $("#hotProductsRecommend").removeClass("none");
      $("#haveCard").removeClass("none");

      var fundsShow = []; //过滤货币基金后的基金列表
      if (data.funds.length > 0) {
        data.funds.forEach(function (e) {
          e.assertMarketValue = toThousands(e.assertMarketValue);
          e.availableShareThousands = toThousands(e.availableShare);

          var rateAndColor = numberFormatter(e.totlam);
          e.totlam = rateAndColor.value;
          e.totlamColor = rateAndColor.color;

          rateAndColor = numberFormatter(e.yestodayPro);
          e.yestodayPro = rateAndColor.value;
          e.yestodayProColor = rateAndColor.color;
          e.isShowFundExit =
            e.isSpecialOutFund == "1" && e.state == e.specialFundState;

          //组合没有持有份额，可用份额
          if (e.isPortfolioAsset === "1") {
            e.total_share = "-";
            e.availableShare = "-";
          }

          if (e.fundCode !== personalFundCode) {
            fundsShow.push(e);
          }
        });
        var htmlList = template("tpl_jl1", { list: fundsShow });
        $("#jl_1").html(htmlList);

        var htmlPage = template("tpl_page", {
          fun: "toPage_1",
          index: pageno,
          pages: Math.ceil(data.funds.length / 10),
        });
        $("#page_1").html(htmlPage);
      } else {
        $("#jl_1").html(
          '<div class="no-bind"><p>抱歉！没有找到您要的信息</p></div>'
        );
      }
    },
    "fundTrading",
    usefundcode
  );
}

function toPage_1(index, pages, type) {
  if (type == 1) {
    if (index + 1 <= pages) {
      apiCcjl(index + 1);
    }
  } else if (type == -1) {
    if (index - 1 >= 1) {
      apiCcjl(index - 1);
    }
  } else {
    var num = 1;
    try {
      num = parseInt($("#toPage_1").html());
    } catch (err) {
      num = 1;
    }
    if (num > 0 && num <= pages) {
      apiCcjl(num);
    }
  }
}

function fundswitch(
  scprodna,
  scfundcode,
  _beforeAvailableShare,
  _afterAvailableShare,
  _sharetype,
  _holdShare,
  _availableShare,
  _limitExflag,
  isPortfolioAsset
) {
  if (isPortfolioAsset == "1") {
    alertIknowMsg("组合持仓暂时无法查看详情");
    return;
  }
  fundMonyInfo.length = 0;
  _sharetype += "";
  clearTipMsg();
  //验证风险等级是否过期

  getReady(
    "5",
    function () {
      isRealName() ? gotoAddmybindbankcard() : gotoFirstbindcard();
    },
    function () {
      gotopersonalInfoAdd("from=0");
    },
    function () {
      window.location.href = window.phURL + "personal/evaluation.html";
    },
    function () {
      //判断用户是否在黑名单中,提示用户该只基金不可转换,0-->禁止转换出，2-->禁止转换
      if (_limitExflag == "0" || _limitExflag == "2") {
        alert("该只基金不可转换");
        return;
      }

      if (
        scfundcode == 0 &&
        beforeAvailableShare == 0 &&
        afterAvailableShare == 0 &&
        sharetype == 0
      ) {
        return;
      }
      toApi_toAcCg(
        "S15Q428",
        { fundCode: scfundcode, shareType: _sharetype },
        function (res) {
          console.log(2222, res);
          if (res.rollDetailList == null || res.rollDetailList.length == 0) {
            console.log(3333);
            fundSwitchApi(
              scprodna,
              scfundcode,
              _beforeAvailableShare,
              _afterAvailableShare,
              _sharetype,
              _holdShare,
              _availableShare,
              _limitExflag,
              isPortfolioAsset
            );
            return;
          }

          if (
            Array.isArray(res.rollDetailList) &&
            res.rollDetailList.length > 0
          ) {
            const transferArr = res.rollDetailList.filter(function (val) {
              return val.redeemFlag == "1";
            });
            console.log("transferArr", transferArr);
            if (transferArr.length == 0) {
              confirm(
                "当前无到期可转换份额，如需要了解每笔份额到期时间，可前往鹏华A加钱包查询",
                "",
                "我知道了",
                "",
                function () {
                  if (getParamsByName("indexFlag") == "1") {
                    history.back();
                  }
                }
              );
            } else if (transferArr.length == 1) {
              nowTransferRollRecordId = transferArr[0].rollRecordId;
              toApi_toAcCg(
                "S15Q402",
                { cashAcctId: transferArr[0].cashAcctId },
                function (data) {
                  console.log(555, data);
                  if (data.respCode == "0000" && data.state == "0") {
                    if (
                      Array.isArray(data.bankCardInfoList) &&
                      data.bankCardInfoList.length > 0
                    ) {
                      isEnable = "Y";
                      redeemCashAcctId = data.bankCardInfoList[0].cashAcctid;
                      redeemBankAcctNo = data.bankCardInfoList[0].cardno;
                      redeemTotalShare = transferArr[0].availableShare;
                      redeemBankCardMsg = data.bankCardInfoList[0].banknm;
                    }
                    $("#canRedeemList").hide();
                    fundswitchNext(
                      scprodna,
                      scfundcode,
                      _beforeAvailableShare,
                      _afterAvailableShare,
                      _sharetype,
                      _holdShare,
                      _availableShare,
                      _limitExflag
                    );
                  } else {
                    alert(data.respMsg);
                  }
                }
              );
            } else {
              var transCfmDate = "";
              var availableShare = "";
              var select = "";
              var liHtml = "";
              var cashAcctId = "";
              //循环遍历赎回列表
              for (var i = 0; i < transferArr.length; i++) {
                transCfmDate = "<p>" + transferArr[i].transCfmDate + "</p>";
                availableShare =
                  "<p>" + transferArr[i].availableShare + "份</p>";
                select =
                  '<p><em class="contextUnchecked" id="myCheck' +
                  i +
                  '"></em></p>';
                liHtml +=
                  '<li onclick="selectTransferLi(' +
                  i +
                  "," +
                  transferArr.length +
                  "," +
                  "'" +
                  scfundcode +
                  "'" +
                  "," +
                  "'" +
                  _sharetype +
                  "'" +
                  "," +
                  "'" +
                  transferArr[i].availableShare +
                  "'" +
                  "," +
                  "'" +
                  transferArr[i].cashAcctId +
                  "'" +
                  "," +
                  "'" +
                  transferArr[i].rollRecordId +
                  "'" +
                  ')">' +
                  transCfmDate +
                  availableShare +
                  select +
                  "</li>";
                // liHtml += '<li onclick="selectRedeemLi('+i+','+transferArr.length+",'000409',0,"+transferArr[i].availableShare+',69000000365)">'+transCfmDate+availableShare+select+'</li>'
              }
              console.log("LIHTML", liHtml);
              $(".canRedeem_list").html(liHtml);
              $(".canRedeemList_close").click(function () {
                if (getParamsByName("indexFlag") == "1") {
                  console.log(123);
                  history.back();
                } else {
                  $("#canRedeemList").hide();
                }
              });
              $(".canRedeemConfirm").click(function () {
                console.log("点击了确定", isSelectTransfer);
                //调S15Q402接口存转换页需要的全局变量
                if (!isNull(isSelectTransfer)) {
                  toApi_toAcCg(
                    "S15Q402",
                    { cashAcctId: nowTransferCashAcctId },
                    function (data) {
                      console.log(555, data);
                      if (data.respCode == "0000" && data.state == "0") {
                        if (
                          Array.isArray(data.bankCardInfoList) &&
                          data.bankCardInfoList.length > 0
                        ) {
                          isEnable = "Y";
                          redeemCashAcctId =
                            data.bankCardInfoList[0].cashAcctid;
                          redeemBankAcctNo = data.bankCardInfoList[0].cardno;
                          redeemTotalShare = nowTransferAvailableShare;
                          redeemBankCardMsg = data.bankCardInfoList[0].banknm;
                        }
                        $("#canRedeemList").hide();
                        fundswitchNext(
                          scprodna,
                          scfundcode,
                          _beforeAvailableShare,
                          _afterAvailableShare,
                          _sharetype,
                          _holdShare,
                          _availableShare,
                          _limitExflag
                        );
                      } else {
                        alert(data.respMsg);
                      }
                    }
                  );
                }
              });
              $("#canRedeemList").show();

              //展示可赎回列表
            }
          }
        }
      );
    }
  );
}

function fundSwitchApi(
  scprodna,
  scfundcode,
  _beforeAvailableShare,
  _afterAvailableShare,
  _sharetype,
  _holdShare,
  _availableShare,
  _limitExflag,
  isPortfolioAsset
) {
  toApi_toAcCg(
    "S060288",
    { optType: "2", fundCode: scfundcode },
    function (data) {
      if (!data.shares || (data.shares && data.shares.length == 0)) {
        alertIknowMsg("当前无可转换份额", true);
        return;
      }
      var htmlMsg = "",
        listHtml = "",
        checkHtml = "",
        bankMsg = "";
      var dataList = data.shares;
      saleBanklist = dataList;
      isEnable = data.isEnable;
      for (var i = 0; i < dataList.length; i++) {
        bankMsg = "<p>" + dataList[i].bankCardMsg + "</p>";
        htmlMsg = "<p>" + toThousands(dataList[i].totalShare) + "份</p>";
        checkHtml =
          '<p><em class="Bank_uncheck" id="checks' + i + '"></em></p>';
        listHtml +=
          '<li onclick="selectOutBank(' +
          i +
          "," +
          dataList.length +
          ",'" +
          dataList[i].cashAcctId +
          "','" +
          dataList[i].bankAcctNo +
          "'," +
          dataList[i].totalShare +
          ')">' +
          bankMsg +
          htmlMsg +
          checkHtml +
          "</li>";
      }
      if (isNull(loadValue("isShowSelect", false))) {
        if (data.isEnable == "Y") {
          $(".redeemList").html(listHtml);
          if (dataList.length > 1) {
            $("#toRedeemBtn").click(function () {
              if (!isNull(isSelected)) {
                $("#selectRedeem").hide();
                fundswitchNext(
                  scprodna,
                  scfundcode,
                  _beforeAvailableShare,
                  _afterAvailableShare,
                  _sharetype,
                  _holdShare,
                  _availableShare,
                  _limitExflag
                );
              }
            });
            $(".closeSelectRedeem").click(function () {
              back();
              $("#selectRedeem").hide();
            });
            $("#selectRedeem").show();
          } else {
            redeemCashAcctId = saleBanklist[0].cashAcctId;
            redeemBankAcctNo = saleBanklist[0].bankAcctNo;
            redeemTotalShare = saleBanklist[0].totalShare;
            fundswitchNext(
              scprodna,
              scfundcode,
              _beforeAvailableShare,
              _afterAvailableShare,
              _sharetype,
              _holdShare,
              _availableShare,
              _limitExflag
            );
          }
        } else {
          fundswitchNext(
            scprodna,
            scfundcode,
            _beforeAvailableShare,
            _afterAvailableShare,
            _sharetype,
            _holdShare,
            _availableShare,
            _limitExflag
          );
        }
      } else {
        fundswitchNext(
          scprodna,
          scfundcode,
          _beforeAvailableShare,
          _afterAvailableShare,
          _sharetype,
          _holdShare,
          _availableShare,
          _limitExflag
        );
      }
    }
  );
}

var transFundType;
var isFastRedeem;
var redeemptionType;
var fundName;
function fundswitchNext(
  scprodna,
  scfundcode,
  _beforeAvailableShare,
  _afterAvailableShare,
  _sharetype,
  _holdShare,
  _availableShare,
  _limitExflag
) {
  useprodna = scprodna;
  usefundcode = scfundcode;
  beforeAvailableShare = _beforeAvailableShare;
  afterAvailableShare = _afterAvailableShare;
  holdShare = _holdShare;
  availableShare = _availableShare;
  transSharetype = _sharetype;
  outShareType = _sharetype === "1" ? "1" : "0";

  toApi(
    "getTransDate.tml?subjectCode=D03601&fundCode=" + usefundcode + "",
    function (data) {
      $("#dateList1").text(data.dateList[0]);
      $("#dateList2").text(data.dateList[1]);
    }
  );

  var fNode = $("#chooseOutTypeLi");
  if (_sharetype === "0") {
    beforeAvailableShare = availableShare;
    fNode.addClass("none");
  } else if (_sharetype === "1") {
    afterAvailableShare = availableShare;
    fNode.addClass("none");
  } else {
    fNode.removeClass("none");
    fNode.html(
      '<span class="left-font">转出份额类型：</span><p id="beforeShow" class="radio-on on"><i></i> <input type="radio" name="paylist" value="0" checked="true" class="radioclass">前收费可用份额<span class="red font-12"> (可用份额：<span id="beforeAvailableShare">' +
        beforeAvailableShare +
        '</span>份)</span></p> <p id="afterShow" class="radio-on" onclick="chooseOutType(\'1\')"><i></i> <input type="radio" name="paylist" value="1" class="radioclass">后收费可用份额 <span class="red font-12"> (可用份额：<span id="afterAvailableShare">' +
        afterAvailableShare +
        "</span>份)</span></p>"
    );
  }

  $("#usefundname").text(useprodna);

  toApi(
    "fundproductdatail.tml?fundCode=" + usefundcode,
    function (data) {
      var listFundMony = data.info.listFundMony;
      nav = data.info.nav * 1.05;
      if (!isNull(data.info.minBalShare)) {
        minBalShare = Number(data.info.minBalShare);
      }
      for (var i = 0; i < listFundMony.length; i++) {
        if (
          listFundMony[i].business_code === "038" &&
          listFundMony[i].cust_type === "1"
        ) {
          fundMonyInfo.push(listFundMony[i]);
        }
      }
      transFundType = data.info.fundType;
      fundName = data.info.fundName;
      if (data.info.isFastRedeem == "1") {
        redeemptionType = "1";
      } else {
        redeemptionType = "0";
      }
      if ($("#sc2").is(":hidden")) {
        $("#conversionShare").val("");
      }
      setTransformationTip(outShareType);
      $("#l1").addClass("none");
      $("#l2").removeClass("none");
    },
    "fundTrading",
    usefundcode
  );
}

function setTransformationTip(outShareType) {
  var limitInfo = "";
  if (!isNull(fundMonyInfo)) {
    for (var i = 0; i < fundMonyInfo.length; i++) {
      if (fundMonyInfo[i].share_type === outShareType) {
        limitInfo = fundMonyInfo[i];
        break;
      }
    }
  }

  if (!isNull(limitInfo) && !isNull(limitInfo.max_subs_share)) {
    var maxSubsShare = Number(limitInfo.max_subs_share);
    var tempAvailableShare =
      outShareType === "0"
        ? Number(beforeAvailableShare)
        : Number(afterAvailableShare);
    // $('#conversionShare').attr('placeholder', "最多可转换" + toThousands(maxSoldValue, 2) + "份");
    if (isNull(redeemTotalShare)) {
      maxSoldValue =
        maxSubsShare > tempAvailableShare ? tempAvailableShare : maxSubsShare;
    } else {
      if (transSharetype == "2") {
        maxSoldValue = Number(beforeAvailableShare);
      } else {
        maxSoldValue = redeemTotalShare;
      }
    }
    setAttrPlaceholderOnEE(
      "conversionShare",
      "最多可转换" + toThousands(maxSoldValue, 2) + "份"
    );
  } else {
    if (isNull(redeemTotalShare)) {
      maxSoldValue =
        outShareType === "0"
          ? Number(beforeAvailableShare)
          : Number(afterAvailableShare);
    } else {
      if (transSharetype == "2") {
        maxSoldValue = Number(beforeAvailableShare);
      } else {
        maxSoldValue = redeemTotalShare;
      }
    }
    // $('#conversionShare').attr('placeholder', "最多可转换" + toThousands(maxSoldValue, 2) + "份");
    setAttrPlaceholderOnEE(
      "conversionShare",
      "最多可转换" + toThousands(maxSoldValue, 2) + "份"
    );
  }
}
function allsw() {
  $("#conversionShare").val(maxSoldValue);
  setFundRate();
}

function before() {
  var indexFlag = getParamsByName("indexFlag");

  if (indexFlag == "1") {
    history.back();
  } else {
    $("#l2").addClass("none");
    $("#l1").removeClass("none");
    $("#sc1").removeClass("none");
    $("#sc2").addClass("none");
  }
}

function scfundinto() {
  $("#l2").addClass("none");
  $("#l3").removeClass("none");
  // usesharetype = $("input[name='paylist']:checked").val();
  //股票型 01
  this.getFundType();
}

function getTopList(fundType) {
  getList(1, fundType, sortType, px, usefundcode, outShareType);
}

function getSortList(sort) {
  if (px == 0) {
    px = 1;
  } else {
    px = 0;
  }
  sortType = sort;
  //区分是否是搜索结果排序
  if (!isNull($("#search").val())) {
    getList(1, fundType, sort, px, $("#search").val());
  } else {
    getList(1, fundType, sort, px, usefundcode, outShareType);
  }
}

function search() {
  var keyword = $("#search").val();
  var pageno = 1;
  var fundType = "ALL";
  var sortType = "1";
  var navSort = "0";
  ["01", "02", "04", "05", "03", "09", "11", "12", "00"].forEach(function (e) {
    $("#t" + e).removeClass("active");
  });

  $("#div_list").html(
    '<table class="deal-list checkbox-wrap sorting" cellpadding="0" cellspacing="0" id="list"></table> <div class="page" id="page"></div>'
  );

  toApi(
    "fundproductlist.tml?pageno=" +
      pageno +
      "&pagesz=10&versionFlag=1&fundType=" +
      fundType +
      "&sortType=" +
      sortType +
      "&navSort=" +
      navSort +
      "&keyword=" +
      keyword,
    function (data) {
      var list1 = [];
      var list2 = [];
      var list3 = [];

      data.infos = handleFundListData(data.infos);
      data.infos.forEach(function (e) {
        if (e.fundType === "04") {
          list2.push(e);
        } else {
          list1.push(e);
        }
      });

      if (list1.length === 0 && list2.length === 0) {
        $("#div_list").html('<p class="text3">抱歉！没有找到您要的信息</p>');
      }
      var htmlList = template("tpl_search", {
        list1: list1,
        list2: list2,
        list3: list3,
      });
      $("#list").html(htmlList);
    },
    "fundTrading",
    usefundcode
  );
}

function getList(pageno, _fundType, sortType, navSort, keyword, shareType) {
  fundType = _fundType;
  //如果是货币型基金传值位9其他为1
  if (fundType === "04") {
    sortType = "9";
  }
  $("#div_list").html(
    '<table class="deal-list checkbox-wrap sorting" cellpadding="0" cellspacing="0" id="list"></table> <div class="page" id="page"></div>'
  );

  ["01", "02", "04", "05", "03", "09", "11", "12", "ALL"].forEach(function (e) {
    if (e == fundType) {
      $("#t" + e).addClass("active");
    } else {
      $("#t" + e).removeClass("active");
    }
  });
  toApi(
    "fundproductlist.tml?pageno=" +
      pageno +
      "&pagesz=10&versionFlag=1&serviceType=2&fundType=" +
      fundType +
      "&sortType=" +
      sortType +
      "&navSort=" +
      navSort +
      "&keyword=" +
      keyword +
      "&share_class=" +
      shareType,
    function (data) {
      if (data.infos.length > 0) {
        data.infos = handleFundListData(data.infos);
        var htmlList = template("tpl_row", {
          list: data.infos,
          fundType: fundType,
        });
        $("#list").html(htmlList);
      } else {
        $("#list").html(
          '<div class="no-bind1"><p>抱歉！没有找到您要的信息</p></div>'
        );
      }
    },
    "fundTrading",
    usefundcode
  );
}

var fundRiskLvDesc = {
  0: "低风险",
  1: "中低风险",
  2: "中风险",
  3: "中高风险",
  4: "高风险",
};

function handleFundListData(fundList) {
  var result = [];
  var personalFundCode = getPersonalFundCode();

  fundList.forEach(function (e) {
    e.riskLevelCn = fundRiskLvDesc[e.riskLevel] || "-";

    var rateAndColor = handleFundRate(e.avgreturnDay);
    e.avgreturnDay = rateAndColor.rate;
    e.avgreturnDayColor = rateAndColor.color;

    rateAndColor = handleFundRate(e.avgreturnMonth);
    e.avgreturnMonth = rateAndColor.rate;
    e.avgreturnMonthColor = rateAndColor.color;

    rateAndColor = handleFundRate(e.avgreturnQuarter);
    e.avgreturnQuarter = rateAndColor.rate;
    e.avgreturnQuarterColor = rateAndColor.color;

    rateAndColor = handleFundRate(e.avgreturnHalfyear);
    e.avgreturnHalfyear = rateAndColor.rate;
    e.avgreturnHalfyearColor = rateAndColor.color;

    rateAndColor = handleFundRate(e.avgreturnYear);
    e.avgreturnYear = rateAndColor.rate;
    e.avgreturnYearColor = rateAndColor.color;

    rateAndColor = handleFundRate_yield(e.yield);
    //alert(rateAndColor.rate+"--"+typeof (rateAndColor.rate)+"--"+parseInt(rateAndColor.rate));0.00%  string 0     yield	0.03004  --> 3.004%
    e.yield = rateAndColor.rate;
    e.yieldColor = rateAndColor.color;

    if (!isNull(e.changeDate)) {
      e.changeDate =
        e.changeDate.substring(0, 4) +
        "-" +
        e.changeDate.substring(4, 6) +
        "-" +
        e.changeDate.substring(6, 8);
    } else {
      e.changeDate = "-";
      e.color = "cello";
    }

    if (!isNull(e.nav)) {
      e.nav = toThousands(e.nav, 4);
    }
    if (e.fundCode !== personalFundCode) {
      result.push(e);
    }
    /*  ywz代码  if(!isNull(e.yield)){
                e.yield = e.yield*100;
                var rateAndColor = handleFundRate(e.yield, 4);
                e.yield = rateAndColor.rate;
                e.yieldColor = rateAndColor.color;
            }*/
  });
  return result;
}
//专门给货币基金写一个函数，类似下面的，因为要单独的*100
function handleFundRate_yield(fundRate) {
  var rateAndColor = {};
  if (!isNull(fundRate)) {
    fundRate = (parseFloat(fundRate) * 100).toFixed(4);
    if (fundRate > 0) {
      fundRate = "+" + fundRate;
      rateAndColor.color = "red";
    } else if (fundRate < 0) {
      rateAndColor.color = "green";
    } else {
      rateAndColor.color = "cello";
    }
    fundRate += "%";
  } else {
    fundRate = "-";
    rateAndColor.color = "cello";
  }
  rateAndColor.rate = fundRate;
  return rateAndColor;
}
function handleFundRate(fundRate) {
  var rateAndColor = {};
  if (!isNull(fundRate)) {
    fundRate = parseFloat(fundRate).toFixed(2);
    if (fundRate > 0) {
      fundRate = "+" + fundRate;
      rateAndColor.color = "red";
    } else if (fundRate < 0) {
      rateAndColor.color = "green";
    } else {
      rateAndColor.color = "cello";
    }
    fundRate += "%";
  } else {
    fundRate = "-";
    rateAndColor.color = "cello";
  }
  rateAndColor.rate = fundRate;
  return rateAndColor;
}

function toPage(index, pages, type) {
  if (type == 1) {
    if (index + 1 <= pages) {
      getList(index + 1, fundType, sortType, px, "");
    }
  } else if (type == -1) {
    if (index - 1 >= 1) {
      getList(index - 1, fundType, sortType, px, "");
    }
  } else {
    var num = 1;
    try {
      num = parseInt($("#toPage").html());
    } catch (err) {
      num = 1;
    }
    if (num > 0 && num <= pages) {
      getList(num, fundType, sortType, px, "");
    }
  }
}

function scfund(intofundName, intofundCode, shareType, fundRiskLv, RiskLvCn) {
  fundRiskLevel = fundRiskLv;
  fundRiskLvCn = RiskLvCn;
  $("#l3").addClass("none");
  $("#l2").removeClass("none");
  $("#sc1").addClass("none");
  $("#sc2").removeClass("none");
  $("#intofundName").text(intofundName);

  useintoprodna = intofundName;
  useintofundcode = intofundCode;
  inShareType = shareType;
  maxLimitAmt = "";
  getMaxamount(useintofundcode);
  gotoProductOverview(useintofundcode);

  var riskLeve = getRiskLv(); //用户风险等级

  if (Number(riskLeve) < Number(fundRiskLv)) {
    //风险等级不匹配
    $("#riskLvNotMatch").removeClass("none");
    flag = 1;
  } else {
    $("#riskLvNotMatch").addClass("none");
    flag = 0;
  }
  $("#e_conversionShare").addClass("none");
}

var twoTip = false;
var threeTip = false;
function next() {
  //输入框金额有效性校验
  conversionShare = $("#conversionShare").val();
  if (isNull($("#intofundName").text()) || $("#sc2").is(":hidden")) {
    errShow("conversionShare", "请选择转入基金");
    return;
  }

  if (isNull(conversionShare, "conversionShare")) {
    errShow("conversionShare", "请输入转换份额");
    return;
  }

  conversionShare = Number(conversionShare);

  var limitInfo = "";
  if (!isNull(fundMonyInfo)) {
    for (var i = 0, len = fundMonyInfo.length; i < len; i++) {
      if (fundMonyInfo[i].share_type === outShareType) {
        limitInfo = fundMonyInfo[i];
        break;
      }
    }
  }

  if (!isNull(limitInfo)) {
    var minAmount = !isNull(limitInfo.min_subs_share)
      ? Number(limitInfo.min_subs_share)
      : "";
    var maxAmount = !isNull(limitInfo.max_subs_share)
      ? Number(limitInfo.max_subs_share)
      : "";

    console.log(limitInfo, "limitInfo", minAmount, maxAmount, conversionShare);
    if (
      !isNull(minAmount) &&
      conversionShare < minAmount &&
      maxSoldValue >= minAmount
    ) {
      errShow("conversionShare", "转出份额不能低于" + minAmount + "份");
      return;
    }
    if (!isNull(maxAmount) && conversionShare > maxAmount) {
      errShow("conversionShare", "转出份额不能高于" + maxAmount + "份");
      return;
    }
  }

  if (isEnable == "Y") {
    var tempAvailableShare = redeemTotalShare;
  } else {
    var tempAvailableShare =
      outShareType === "0"
        ? Number(beforeAvailableShare)
        : Number(afterAvailableShare);
  }

  if (tempAvailableShare - conversionShare < minBalShare) {
    if (tempAvailableShare - conversionShare > 0) {
      errShow("conversionShare", "请保留" + minBalShare + "份以上或全部转出");
      return;
    }

    if (tempAvailableShare - conversionShare < 0) {
      errShow(
        "conversionShare",
        "超出最多可转份额" + tempAvailableShare + "份"
      );
      return;
    }
  }

  //判断选择框是否选中，显示不同的状态图片，不选择不允许确定进行下一步
  if (!isSelect) {
    alert("请阅读相关协议并确认勾选");
    return;
  }

  // 如果客户可以使用鹏豆且未选择使用鹏豆且手续费所需要鹏豆数量小于等于持有鹏豆数量，提示客户是否需要使用鹏豆
  if (
    isAllowUse === "1" &&
    !isSelect1 &&
    creditNum > 0 &&
    noPengDouContinueNextFlag == "0" &&
    (!maxLimitAmt || maxNum < maxLimitAmt)
  ) {
    $("#unUseBean").css("display", "block");
    return;
  }
  if (
    isSelect1 &&
    creditNum > 0 &&
    isAllowUse === "1" &&
    (!maxLimitAmt || maxNum < maxLimitAmt)
  ) {
    creditUseType = "C36"; //鹏豆使用场景
    creditValue = 1; //鹏豆使用场景
  } else {
    creditUseType = ""; //鹏豆使用场景
    creditValue = ""; //鹏豆使用场景
  }

  var S15Q128Params = {
    fundCode: getParamsByName("scfundcode"),
    shareType: getParamsByName("sharetype") || "0",
    occurShare: conversionShare,
    transCode: "02410",
  };
  toApi_toAcCg(
    "S15Q128",
    S15Q128Params,
    function (data) {
      console.log(data);
      if (data.punitiveFlag == "1") {
        var message =
          "您转换份额中有" +
          data.punitiveShare +
          "份持有未满" +
          data.punitiveDays +
          "个自然日，将收取" +
          data.punitiveRate +
          "%惩罚性赎回费，";
        if (data.suggestShare && Number(data.suggestShare) > 0) {
          message = message + "建议您修改为" + data.suggestShare + "份以内，";
        }
        message += "是否继续转换？";
        confirm(message, "暂不", "继续转换", "", function () {
          buyFund();
        });
      } else {
        buyFund();
      }
    },
    function (err) {
      buyFund();
    }
  );
}

function buyFund() {
  fundPurchase(
    fundRiskLevel,
    function () {
      twoTip = true;
      var riskLevelMsg = localStorage.riskLevelDesc;
      confirm2(
        '您的风险承受能力为<i class="red" style="font-size: 18px">' +
          riskLevelMsg +
          '</i>，您目前购买产品的风险类别为<i class="red" style="font-size: 18px">' +
          fundRiskDesc[fundRiskLevel] +
          "</i><br />您目前购买的产品风险类别已经高于您的风险承受能力，您可能因此面临超过您风险承受能力的投资亏损，请谨慎投资。<br/>您未收到本公司及销售人员主动推介本基金的任何信息，对此您充分认可。<br />是否确认继续交易？<br />",
        "放弃交易",
        "继续购买",
        "",
        getOutLine
      );
    },
    getOutLine,
    function () {
      threeTip = true;
      riskHighTip(useintofundcode);
    },
    useintofundcode,
    fundRiskLvCn
  );
}

var outLineId;
function getOutLine() {
  toApi_toAcCg(
    "S15Q146",
    { type: 0, codes: [useintofundcode] },
    function (data) {
      if (!isNull(data) && data.hasSummary == "1") {
        if (
          !isNull(data) &&
          !isNull(data.data) &&
          data.data.length > 0 &&
          !isNull(data.data[0].summary)
        ) {
          outLineId = data.data[0].id;
          // var url = data.data[0].summary.replace("http://", "//");
          var arr = data.data.map(function (val, index) {
            return {
              eq: index,
              title: val.agreementName,
              src: val.summary.replace("http://", "//"),
              hasRead: false,
            };
          });
          fundSummaryArr = data.data.map(function (val) {
            return {
              fundCode: useintofundcode,
              productInfoId: val.id,
              transCode: "020", // 认申购020，定投039，转换036
              ptfCode: 0,
            };
          });
          showOutLine(arr);
        } else {
          gotoInputPassword();
        }
      } else {
        if (fundType != "04" && fundType != "08") {
          if (data && (!data.data || data.data.length === 0)) {
            alertMsg("该产品无资料概要，暂时无法交易，请联系客服");
            return;
          }

          // if (Object.keys(data.readedFundSummaries).length > 0) {
          //     gotoInputPassword();
          //     return;
          // }
        } else {
          gotoInputPassword();
        }
      }
      // if (!isNull(data) && fundType != '04') {
      //     if (!isNull(data) && !isNull(data.data) && data.data.length > 0 && !isNull(data.data[0].summary) && data.hasSummary == '1') {
      //         outLineId = data.data[0].id;
      //         // var url = data.data[0].summary.replace("http://", "//");
      //         var arr= data.data.map(function(val,index){
      //             return {
      //                 eq:index,
      //                 title:val.agreementName,
      //                 src:val.summary.replace("http://", "//"),
      //                 hasRead:false
      //             }
      //         })
      //         fundSummaryArr = data.data.map(function(val){
      //             return {
      //                 fundCode:fundCode,
      //                 productInfoId:val.id,
      //                 transCode: "020", // 认申购020，定投039，转换036
      //                 ptfCode: 0

      //             }
      //         })
      //         showOutLine(arr);
      //     } else {
      //         gotoInputPassword();
      //     }
      // } else {
      //     if (fundType != '04') {
      //         if (data && (!data.data || data.data.length === 0)) {
      //             alertMsg('该产品无资料概要，暂时无法交易，请联系客服');
      //             return;
      //         }

      //         // if (Object.keys(data.readedFundSummaries).length > 0) {
      //         //     gotoInputPassword();
      //         //     return;
      //         // }
      //     } else {
      //         gotoInputPassword();
      //     }
      // }
    },
    "",
    "",
    function (err) {
      alertMsg("该产品无资料概要，暂时无法交易，请联系客服");
    }
  );
}
function gotoFundBuy() {
  // {
  //     fundCode: useintofundcode,
  //     productInfoId: isNull(outLineId) ? loadValue("summaryID", false) : outLineId,
  //     transCode: "036", // 认申购020，定投039，转换036
  //     ptfCode: 0
  // }
  if (!loadValue("unScrollbottom", false)) {
    alert("请先完成全文阅读");
    return;
  }
  removeValue("unScrollbottom", false);
  $("#pupFundOutline").hide();
  var S092019params = {
    fundSummaryVos: fundSummaryArr,
    source: "fundTrading",
  };
  toApi_toAc(
    "S092019",
    S092019params,
    function () {
      removeValue("summaryID", false);
      gotoInputPassword();
    },
    "",
    "",
    function (err) {
      gotoInputPassword();
    }
  );
}

function readNext() {
  console.log(222222, itemArr);
  //循环对象，找到下一个未读的展示，如果找不到，则代表全部已读，执行之后的业务逻辑
  noReadArr = itemArr.filter(function (val) {
    return val.hasRead == false;
  });
  console.log(33333, noReadArr);
  if (noReadArr.length == 0) {
    $("#pupFundOutline").hide();
    var S092019params = {
      fundSummaryVos: fundSummaryArr,
      source: "fundTrading",
    };
    toApi_toAc(
      "S092019",
      S092019params,
      function () {
        removeValue("summaryID", false);
        gotoInputPassword();
      },
      "",
      "",
      function (err) {
        gotoInputPassword();
      }
    );
  } else {
    // nowIndex = noReadArr[0].eq;
    console.log(nowIndex);

    if (itemArr[nowIndex].hasRead) {
      if (parseInt(nowIndex) + 1 == itemArr.length) {
        nowIndex = 0;
      } else {
        nowIndex++;
      }
      $(".outLine_box").eq(nowIndex).show().siblings().hide();
      $(".titleItem")
        .eq(nowIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
      return;
    }
    itemArr[nowIndex].hasRead = true;

    hasReadNum = itemArr.filter(function (val) {
      return val.hasRead == true;
    }).length;
    if (parseInt(hasReadNum) < itemArr.length) {
      $(".nextBtn2").text(
        "我已阅读并知悉(" + hasReadNum + "/" + itemArr.length + ")"
      );
    } else {
      readNext();
    }

    if (parseInt(nowIndex) + 1 == itemArr.length) {
      nowIndex = 0;
    } else {
      nowIndex++;
    }
    $(".outLine_box").eq(nowIndex).show().siblings().hide();
    $(".titleItem")
      .eq(nowIndex)
      .addClass("active")
      .siblings()
      .removeClass("active");
  }
}

function gotoInputPassword() {
  $("#e_conversionShare").addClass("none");
  // $('#h1').removeClass('active');
  $("#h2").addClass("active");
  $("#r1").addClass("none");
  $("#r2").removeClass("none");
  $("#n1").addClass("none");
  $("#n2").removeClass("none");
  $("#riskLvNotMatch").addClass("none");
  $("#confirmoutfund").text(useprodna);
  $("#confirmintofund").text(useintoprodna);

  if (outShareType === "0") {
    $("#confirfundway").text("前收费可用份额");
  } else if (outShareType === "1") {
    $("#confirfundway").text("后收费可用份额");
  }

  $("#confirmfundmath").html(toThousands(conversionShare, 2) + "份");
  document.getElementById("riskHighTip").style.display = "none";
}

function before2() {
  $("#h2").removeClass("active");
  $("#h1").addClass("active");
  $("#r2").addClass("none");
  $("#r1").removeClass("none");
  $("#n2").addClass("none");
  $("#n1").removeClass("none");
  $("#paySc").val("");
  if (flag === 1) {
    $("#riskLvNotMatch").removeClass("none");
  }
  noPengDouContinueNextFlag = "0";
  closeKeypad();
}

function switchfund() {
  //校验是否绑定银行卡
  closeKeypad();
  if (!isHaveBankCardn()) {
    document.getElementById("unBindCard").style.display = "";
    return;
  }
  $("#e_paySc").addClass("none");

  var paySc = $("#paySc").val();
  if (isNull(paySc)) {
    errShow("paySc", "交易密码还未输入，请先输入交易密码");
    return;
  }
  if (!checkTransPwd2("paySc", "交易密码不合法")) {
    return;
  }

  $("#paySc").val("");
  //通过[密钥下发]接口获取密码RSA秘钥
  toApi(
    "getPubKey.tml?type=" + 2,
    function (data) {
      var publicKey = data.key;
      var r_p = RSAUtil_transPwd(paySc, publicKey);

      var s_oneTip = false;
      var s_twoTip = false;
      if (oneTip) s_oneTip = true;
      if (twoTip || threeTip) s_twoTip = true;

      var myRiskLevel = localStorage.risklv;
      //如果让后端校验强制交易，risk应该为0
      if ("1" != loadValue("isDealWithNotMatch", false)) {
        flag = "0";
      }
      console.log(loadValue("isNeedRiskLog", false));
      // var isNeedRiskLog = loadValue('isNeedRiskLog',false);
      // var confirmFundClosedInfo = ('0' == loadValue('riskInvestPlanMatchFlag',false)) ? loadValue('isNeedRiskLogString',false):'';

      var params = {
        fundCode: usefundcode,
        targetFundCode: useintofundcode,
        cashAcctid: redeemCashAcctId,
        entrustWay: "3",
        transPwd: r_p,
        shareType: inShareType,
        transCode: "03601",
        flag: "0",
        fundType: transFundType,
        redeemType: redeemptionType,
        limitFlag: "0",
        taNo: "06",
        fundRiskLevel: fundRiskLevel,
        myRiskLevel: myRiskLevel,
        // deviceId:"shebeihaoshipc",
        // device_type:"01",
        operation: "transfer",
        riskMatchFlag: oneTip ? "1" : "0",
        creditUseType: creditUseType,
        creditValue: creditValue,
        confirmFundSummary: hasFundSummary,
        occurShare: conversionShare,
        fundName: fundName,
      };
      if (oneTip) {
        params.oneTip = oneTip;
        params.twoTip = twoTip;
      }
      if (nowTransferRollRecordId) {
        params.rollRecordId = nowTransferRollRecordId;
      }
      //通过[基金转换]接口对基金进行转换
      toApi_toAcCg(
        "S060237",
        params,
        function (data) {
          var res = {};
          if (data.respData) {
            res = data.respData;
          } else {
            res = data;
          }

          console.log(res);
          if (res.state == "0" || res.state == "9") {
            clearRiskInvestPlanMatchContinue();
            $("#h3").addClass("active");
            $("#r2").addClass("none");
            $("#r3").removeClass("none");
            $("#r4").removeClass("none");
            $("#n2").addClass("none");
            $("#n3").removeClass("none");
            $("#riskLvNotMatch").addClass("none");
            var submitTime = res.submitTime;
            $("#submitTime").text(submitTime);
            var confirmDate = res.confirmDate;
            $("#confirmDate").text(confirmDate);
            var balanceDate = res.incomeDate;
            $("#balanceDate").text(balanceDate);
          } else if (res.state == "1" && res.respMsg) {
            alertMsg(res.respMsg);
          } else {
            if (res.jsonData && res.jsonData.isLimitedFlag == "1") {
              alertMsg(
                "交易密码错误已经连续错误5次，请24小时后再试或找回交易密码"
              );
            } else if (res.jsonData && res.jsonData.isLimitedFlag == "0") {
              alertMsg(
                "交易密码错误" +
                  res.jsonData.errorTimes +
                  "次，连续错误5次后交易将会锁定"
              );
            } else {
              if (res.respMsg) {
                alertMsg(res.respMsg);
              }
            }
          }
        },
        "",
        "",
        function (error) {
          if (error && error.message && error.message.includes("timeout")) {
            alertMsg("交易处理超时，请稍后再试!");
          }
        },
        true
      );
    },
    "fundTrading",
    usefundcode
  );
}

function back() {
  var indexFlag = getParamsByName("indexFlag");
  $("#l1").removeClass("none");
  $("#l2").addClass("none");
  if (indexFlag == "1") {
    history.back();
  } else location.reload();
}

function backToTransferPage() {
  $("#l2").removeClass("none");
  $("#l3").addClass("none");
}

/**
 * 清除提示信息
 */
function clearTipMsg() {
  $("#e_conversionShare").addClass("none");
  $("#riskLvNotMatch").addClass("none");
}

function goDetail(pageId, fundCode, fundType, isPortfolioAsset, productCode) {
  //组合详情
  if (isPortfolioAsset == "1") {
    alertIknowMsg("组合持仓暂时无法查看详情");
    return;
  } else if (
    productCode == "目标盈" ||
    productCode == "止盈" ||
    productCode == "智能定投"
  ) {
    combinedTip("本产品需通过A加钱包APP进行查看");
  } else {
    window.location.href =
      window.phURL + pageId + "?fundCode=" + fundCode + "&fundType=" + fundType;
  }
}

// 基金产品概要
function selectAgree() {
  isSelect = !isSelect;

  if (isSelect) {
    $("#checkBox1").hide();
    $("#checkBox2").hide();
    $("#checkBox3").show();
  } else {
    $("#checkBox1").show();
    $("#checkBox2").hide();
    $("#checkBox3").hide();
  }
}

function gotoProductOverview(useintofundcode) {
  var params = {
    codes: [useintofundcode],
    type: 0,
  };
  toApi_toAcCg(
    "S15Q028",
    params,
    function (data) {
      try {
        summary = data.data[0]["summary"];
        fundInstructions = data.data[0]["recruitmentBook"];
        fundContract = data.data[0]["contract"];
        if (summary || fundInstructions || fundContract) {
          hasFundSummary = 1;
          $("#hasFundSummary").show();
          $("#noFundSummary").hide();
        } else {
          $("#hasFundSummary").hide();
          $("#noFundSummary").show();
        }
        if (!fundInstructions) {
          $(".instructions").hide();
        }
        if (!summary) {
          $(".summary").hide();
        }
        if (!fundContract) {
          $(".fundContract").hide();
        }
      } catch (e) {
        $("#hasFundSummary").hide();
        $("#noFundSummary").show();
      }
    },
    function (error) {
      $("#hasFundSummary").hide();
      $("#noFundSummary").show();
    }
  );
  $("#fundSummaryImg").show();
}

function openPdf(pdfUrl) {
  if (!pdfUrl) {
    return;
  }
  window.open(pdfUrl);
  $(".mask").css("display", "none");
  $(".agreementList").css("display", "none");
}
function openAgreement() {
  $(".mask").css("display", "block");
  $(".agreementList").css("display", "block");
}
function agreementKnow() {
  $(".mask").css("display", "none");
  $(".agreementList").css("display", "none");
}

// 是否使用鹏豆
function selectAgree1() {
  isSelect1 = !isSelect1;

  if (isSelect1) {
    $("#checkBox4").hide();
    $("#checkBox5").hide();
    $("#checkBox6").show();
    noPengDouContinueNextFlag = "0";
  } else {
    $("#checkBox4").show();
    $("#checkBox5").hide();
    $("#checkBox6").hide();
  }
}
function useBean() {
  noPengDouContinueNextFlag = "0";
  selectAgree1();
  next();
}
function unUseBean() {
  noPengDouContinueNextFlag = "1";
  next();
}

function getMaxamount(useintofundcode) {
  toApi("qryfundrate.tml?fundCode=" + useintofundcode, function (data) {
    var list = data.list;
    var iteamlist;
    for (var i = 0; i < list.length; i++) {
      if (list[i].transType == "022") {
        iteamlist = list[i].iteamlist;
      }
    }
    for (var j = 0; j < iteamlist.length; j++) {
      if (iteamlist[j].fee_type == "1") {
        fee_const = iteamlist[j].fee_const.toFixed(2);
        maxLimitAmt = isNull(iteamlist[j].amountMin)
          ? ""
          : "" + iteamlist[j].amountMin; //固定费用限额
      }
    }
    //是否需要手续费：false:不需要；true:需要
    isNeedFee = !(
      isNull(iteamlist) ||
      iteamlist.length == 0 ||
      iteamlist[0].rateStandards == 0
    );
    if (fundType != "04" && isNeedFee) {
      // 不是货币型,前收费 且 有手续费
      getBean(useintofundcode); //查询鹏豆
    }
  });
}

function setFundRate() {
  var buyAmount = $("#conversionShare").val();
  if (!isNull(buyAmount) && isAllowUse == "1") {
    var reg = /^[0-9]*$/;
    var reg1 = /^[0-9]+(.[0-9]{0,2})?$/;
    if (reg.test(buyAmount) || reg1.test(buyAmount)) {
      buyAmount = Number(buyAmount);
      maxNum = buyAmount * nav;
      if (maxNum >= maxLimitAmt && maxLimitAmt) {
        $("#beanTips").html(
          "转换金额过大可能会触发收取" +
            fee_const +
            "元固定手续费，您可考虑分笔转换，使用鹏豆减免申购补差费"
        );
      } else {
        $("#beanTips").html(
          "使用1个鹏豆抵扣转换手续费，根据基金交易规则存在未能完全抵扣的情况，具体抵扣金额以实际为准"
        );
      }
    }
  }
}

function selectOutBank(index, length, cashAcctId, bankAcctNo, totalShare) {
  for (var i = 0; i < length; i++) {
    if (index == i) {
      $("#checks" + i).attr("class", "Bank_check");
    } else {
      $("#checks" + i).attr("class", "Bank_uncheck");
    }
  }
  isSelected = 1;
  redeemCashAcctId = cashAcctId;
  redeemBankAcctNo = bankAcctNo;
  redeemTotalShare = totalShare;
  redeemBankCardMsg = saleBanklist[index].bankCardMsg;
}

// 新代码
function getTransPosition() {
  var params = {
    agencyNo: "APLUS",
    channelCode: "",
  };
  toApi_toAcCg(
    "S15Q427",
    params,
    function (res) {
      if (res.fundList.length === 0 && res.spFundList.length === 0) {
        $("#unbindCard").removeClass("none");
        // setUnBindCardInfo('暂无持仓数据', '', 'wallet/recharge.html');
        return;
      }

      $("#haveCard").removeClass("none");
      // 基金
      var fundList = [];
      res.fundList.forEach(function (item) {
        if (item.detailList && item.detailList.length > 0) {
          item.detailList.forEach(function (detail) {
            if (detail.mainFlag == "1" && Number(detail.availableAmount) > 0) {
              fundList.push(detail);
            } else if (detail.mainFlag == "0") {
              fundList.push(detail);
            }
          });
        } else {
          fundList.push(item);
        }
      });
      fundList.forEach(function (fund) {
        fund.formatAvailableAmount = toThousands(fund.availableAmount);
        fund.formatAvailableShare = toThousands(fund.availableShare);
        fund.formatTotalShare = toThousands(fund.totalShare);
        fund.isPortfolioAsset = "0";

        var dayIncome;
        if (fund.dayIncomeMap && Object.keys(fund.dayIncomeMap).length > 0) {
          dayIncome = fund.dayIncomeMap[fund.profitCalculateDate] || 0.0;
        }
        fund.formatDayProfitAmount = numberFormatter(dayIncome).value;
        fund.formatDayProfitAmountColor = numberFormatter(dayIncome).color;
        var income =
          fund.fundType == "04"
            ? fund.profitAmountTotal
            : fund.holdProfitAmount;
        fund.formatIncome = numberFormatter(income).value;
        fund.formatIncomeColor = numberFormatter(income).color;
        fund.profitDateText =
          new Date().toLocaleDateString().replace("/", "").replace("/", "") ===
          fund.profitCalculateDate
            ? "今日"
            : "昨日";

        fund.productName = fund.productName ? fund.productName : fund.fundName;
        if (fund.portfolioType && fund.portfolioType == "TP") {
          fund.productCode = "目标盈";
        } else if (fund.portfolioType && fund.portfolioType == "TY") {
          fund.productCode = "止盈";
        } else if (fund.portfolioType && fund.portfolioType == "IP") {
          fund.productCode = "智能定投";
        } else {
          fund.productCode = fund.productCode
            ? fund.productCode
            : fund.fundCode;
        }
      });
      console.log(fundList);
      if (fundList.length > 0) {
        var htmlList = template("tpl_jl1", { list: fundList });
        $("#jl_1").html(htmlList);

        // var htmlPage = template('tpl_page', {
        //     "fun": "toPage_1",
        //     "index": pageno,
        //     "pages": Math.ceil(fundList.length / 10)
        // });
        // $('#page_1').html(htmlPage);
      } else {
        $("#jl_1").html(
          '<div class="no-bind"><p>抱歉！没有找到您要的信息</p></div>'
        );
      }
    },
    "fundTrading",
    usefundcode
  );
}

// 点击转换按钮
function gotoTransfer(
  fundCode,
  availableShare,
  holdShare,
  isPortfolioAsset,
  productCode
) {
  if (
    productCode == "目标盈" ||
    productCode == "止盈" ||
    productCode == "智能定投"
  ) {
    combinedTip("本产品需通过A加钱包APP进行查看");
    return;
  }
  toApi_toAcCg("S15Q032", { fundCode: fundCode }, function (value) {
    var beforeAvailableShare;
    var afterAvailableShare;
    value.shareType == "0"
      ? (beforeAvailableShare = availableShare)
      : (afterAvailableShare = availableShare);

    fundswitch(
      value.fundName,
      fundCode,
      beforeAvailableShare,
      afterAvailableShare,
      value.shareType,
      holdShare,
      value.availableShare,
      value.limitExflag,
      isPortfolioAsset
    );
  });
}
